export class Document {
  constructor(
    public id?: number,
    public index?: number,
    public url?: string,
    public title?: string,
    public filename?: string,
    public languageId?: string,
    public isWarranty?: boolean,
    public contentType?: string,
    public link?: string,
    public file?: File | null,
    public storageUri?: string,
    public externalLink?: string,
    public status?: DocumentStatus,
    public description?: string,
    public serialNumbers?: string[],
    public articleCodes?: string[]
  ) {}
}

export enum DocumentStatus {
  NOT_PUBLISHED = 0,
  PUBLISHED = 1,
}

export class Media {
  constructor(
    public id?: number,
    public articleIds?: number[],
    public storageUri?: string,
    public contentType?: string | CustomContentType
  ) {}
}

export class ImageMedia {
  constructor(
    public id?: number,
    public index?: number,

    public articleIds?: number[],
    public storageUri?: string,
    public contentType?: CustomContentType,
    public file?: File,
    public languageId?: string,
  ) {}
}

export class VideoMedia {
  constructor(
    public id?: number,
    public index?: number,

    public articleIds?: number[],
    public storageUri?: string,
    public externalLink?: string,
    public thumbnailLink?: string,
    public contentType?: CustomContentType,
    public file?: File,
    public src?:string,
    public languageId?: string,
  ) {}
}

export class VideoLinks {
  constructor(public externalLink?: string, public thumbnailLink?: string) {}
}

export class VideoMediaPost {
  constructor(
    public articleIds?: number[],
    public externalLink?: string,
    public contentType?: CustomContentType
  ) {}
}

export class ImageMediaPost {
  constructor(public articleIds?: number[], public file?: File) {}
}

export enum CustomContentType {
  IMAGE = 0,
  VIDEO = 1,
}

export enum CustomContentString {
  IMAGE = 'image/external-link',
  VIDEO = 'video/external-link',
}

export enum ContentType {
  IMAGE,
  VIDEO,
  UNKNOWN,
}

export const validDocumentExtensions: string[] = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'csv',
];

export const validImagesExtensions: string[] = [
  'jpg',
  'jpeg',
  'png',
  'bmp',
  'tiff',
];

export const validVideosExtensions: string[] = [
  'mp4',
  'webm',
];

export enum VideoType {
  EXTERNAL = 'External',
  FILE = 'File'
}
